export default __webpack_public_path__ + "static/media/bulb.9fe1a02d.svg";